import React, { useState } from "react";
import { Button, Popover } from "antd";
import Services from "../../Services/dataService";
import ProgressBar from "./ProgressBar";
import axios from "axios";

function DownloadShops({ title, key, dispatch, apiTracking, buttonLabel }) {
	let [popOverOpsn, setPopOverOpen] = useState(false);

	return (
		<div className="pr-3 flex-row py-2">
			{
				<Popover
					className="primaryclr"
					placement="rightBottom"
					content={
						<div style={{ "max-height": "75vh", "overflow-y": "auto" }} className="border-none shadow ">
							<table
								className="table table-striped table-borderedx table-hover border-none"
								style={{ width: "100%" }}
							>
								<tr>
									<th className="elipsis-count">Title</th>
									<th className="elipsis">Action/Status</th>
									{/* <th className="elipsis">Available Shops</th> */}
									<th className="elipsis">Downloading</th>

									{/* <th className="elipsis">Shops Available</th> */}
								</tr>

								<tr>
									{
										<>
											<td className="elipsis-count">All Shops</td>
											<td className="elipsis " style={{ height: "46px" }}>
												{apiTracking[key] || (
													<Button
														className="shop-download-btn"
														onClick={async () => {
															const source = axios.CancelToken.source();

															dispatch({
																type: "setObject",
																actions: {
																	set: {
																		[`apiTracking.${key}`]: (
																			<Button
																				className="shop-download-btn"
																				onClick={async () => {
																					source.cancel(
																						"Operation canceled by the user."
																					);
																					dispatch({
																						type: "setObject",
																						actions: {
																							set: {
																								[`apiTracking.${key}`]:
																									null
																							}
																						}
																					});
																				}}
																			>
																				Cancel
																			</Button>
																		)
																	}
																}
															});
															let { data } = await Services.fetchALLClientShops({
																source,
																onDownloadProgress: progressEvent => {
																	const { loaded, total } = progressEvent;
																	const divisor = 1048576;
																	const percent = Math.round(
																		(progressEvent.loaded * 100) /
																			progressEvent.total
																	);
																	dispatch({
																		type: "setObject",
																		actions: {
																			set: {
																				[`apiTracking.${key}-Downloading`]: {
																					abbr: "Mbs",
																					loaded,
																					total,
																					divisor,
																					percent
																				}
																			}
																		}
																	});
																}
															});
															let all_raw_tenant_markers = {};
															data?.forEach(
																({
																	location: {
																		coordinates: [lng, lat]
																	},
																	name,
																	_id
																}) => {
																	all_raw_tenant_markers[_id] = {
																		id: _id,
																		isPoi: true,
																		label: name,
																		position: {
																			lat,
																			lng
																		},
																		showInfo: true
																	};
																}
															);

															dispatch({
																type: "setObject",
																actions: {
																	set: {
																		all_raw_tenant_markers,
																		[`apiTracking.${key}`]: "Completed"
																	}
																}
															});
														}}
													>
														Download
													</Button>
												)}
											</td>

											<td className="elipsis ">
												{<ProgressBar data={apiTracking[`${key}-Downloading`]} />}
											</td>
										</>
									}
								</tr>
							</table>
						</div>
					}
					title={title}
					trigger="hover"
					open={popOverOpsn}
					onOpenChange={value => {
						setPopOverOpen(value);
					}}
				>
					<Button>{buttonLabel}</Button>
				</Popover>
			}
		</div>
	);
}

export default DownloadShops;
